import React from 'react';

export default function BoardArrow() {
  return (
    <svg
      width="49"
      height="13"
      viewBox="0 0 49 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.5 6.5L38.5 0.726497V12.2735L48.5 6.5ZM0.5 7.5H39.5V5.5H0.5V7.5Z"
        fill="#A7A5BA"
      />
    </svg>
  );
}
